import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const database: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M2.547-6.328Q4.154-6 6-6q1.858 0 3.469-.328 1.605-.343 2.531-1V-6q-.002.532-.812 1-.799.455-2.188.734Q7.623-3.998 6-4a16 16 0 0 1-3.016-.266Q1.606-4.546.797-5 0-5.468 0-6v-1.328q.937.657 2.547 1m0 6Q4.154 0 6 0q1.858 0 3.469-.328 1.605-.342 2.531-1V0q-.002.544-.812 1c-.532.313-1.262.555-2.188.734Q7.623 2 6 2q-1.628-.001-3.016-.266C2.066 1.554 1.336 1.313.797 1Q0 .544 0 0v-1.328c.625.437 1.473.773 2.547 1m0-3Q4.154-3 6-3q1.858 0 3.469-.328 1.605-.342 2.531-1V-3q-.002.533-.812 1-.799.456-2.188.734C8.082-1.086 7.082-1 6-1a16 16 0 0 1-3.016-.266Q1.606-1.546.797-2 0-2.467 0-3v-1.328c.625.437 1.473.773 2.547 1m.437-8.406Q4.372-12 6-12q1.623.001 3 .266c.926.18 1.656.422 2.188.734q.81.457.812 1v1q-.002.532-.812 1c-.532.305-1.262.547-2.188.734Q7.623-6.998 6-7a16 16 0 0 1-3.016-.266Q1.606-7.546.797-8 0-8.468 0-9v-1q0-.543.797-1 .81-.467 2.187-.734m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "12",
  }
};